angular
  .module("digitalLeasing.module")
  .component("checkListDownload", {
    templateUrl: "ng/components/digitalLeasing/checkList/checkListDownload/checkListDownload.view.html",
    bindings: {
      model: "=",
      uploadStart: "<",
      checkListDownload: "&",
      enableButton: "<",
      visibleButton: "<",
      contractSent: "&",
      snapshot: '<',
      portalRunned:"<"
    },
    controllerAs: "checkListDownloadCtrl",
    controller: checkListDownloadController


  });

function checkListDownloadController(
  $simulationService,
  $configService,
  $portalService,
  $rootScope,
  $modalService,
  $scope,
  $typeDomainService,
  FlagArc,
  $download

) {
  var self = this;

  self.validationObj = {
        documentDate: {
            disabledDays: [0],
            disabledDates: [
                "01-01",
                "06-01",
                "25-04",
                "01-05",
                "02-06",
                "15-08",
                "01-11",
                "08-12",
                "25-12",
                "26-12"
            ]
        }
  };

  self.$onInit = function () {
    self.model = self.model;
    self.showLoader=false;
    self.toggles = [];
    getPopulation(self.model);
    self.$portalService = $portalService;
    self.enableConfermButton=false;
    self.enableButton= false;
    self.tomorrow = moment()
                    .add(1, "days")
                    .format("DD/MM/YYYY");
    popolateControlCheckBox();
  };

 
  self.$onChanges = function (changes) {
    if (changes.uploadStart && typeof changes.uploadStart.currentValue != "undefined") {
      self.disabledDownloadButton = changes.uploadStart.currentValue;
    }

    if(changes.enableButton){

    self.enableButton= changes.enableButton.currentValue;
    self.checkPerson();
    }
    if(changes.visibleButton){
    self.visibleButton= changes.visibleButton.currentValue;
    self.checkPerson();
    }
  }



  self.generdownloadDoc = function (file) {
    var input={
        downloadKey: file.downloadKey
      }
      var url="/uni/downloadDocDigital/service-infos/"
      $download.getGenericDownload(url, input)
      .then(function(response){
        console.log(response)
      })
  };

  self.fileIsDownloaded = function (index, file) {
    self.generdownloadDoc(file)
    self.listFileDownload[index].downloaded = true;

    var downloadedIsPresent = self.model.leasingData.preventivo.documents.downloaded
                .some(function(e){ 
                  return e.cdDoc == self.listFileDownload[index].cdDoc
                  })

    if(!downloadedIsPresent){
      self.model.leasingData.preventivo.documents.downloaded.push(self.listFileDownload[index]);
    }
    everyFileIsDownloaded();
  }

  var everyFileIsDownloaded = function () {
    var test = self.listFileDownload && self.listFileDownload
      .every(function (element) {
        return element.downloaded == true;
      })
    if($portalService.isAru()){
      test = test && self.model.leasingData.preventivo.flagsArc
      .filter(function(e){
        return e.value === 'RICHIESTA'
      })
      .every(function(element){
        return element.selected == true;
      })
    }
    if (test) {
      self.checkListDownload({
        value: false
      });
      return;
    }
    self.checkListDownload({
      value: true
    });
  }

  var getPopulation = function (model) {
    $simulationService
      .populateDownloadCheckList(model)
      .then(function (response) {
        self.listFileDownload = response.documents;


      })
      .catch(function (error) {
        console.log("Error", error);
      })
      .finally(function () { 
        everyFileIsDownloaded();
      })

  }

  var getWizardMap = function(viewIndex){
        return $rootScope.wizardMap
                  .find(function(element){
                        return element.index == viewIndex
                  }).viewName
  }

  self.enabledButton = function(){

    return self.enableConfermButton && 
    !!self.model.financialCustomer.metadata.adeguataVerifica.dataRiconoscimento
  }


  self.checkPerson = function(){

    var result= self.model.financialCustomer.metadata.riUserF.listaPf
            .some(function(element){
              return element.personalDocsComplete == false
            })

    return result;
  }

  self.getTomorrowDate = function () {
                return moment()
                .add(1,"days")
                .format("DD/MM/YYYY");
  }

  var getWizardMap = function (viewIndex) {
    return $rootScope.wizardMap.find(function (element) {
      return element.index == viewIndex;
    }).viewName;
  };

  var popolateControlCheckBox = function(){
    $typeDomainService
          .getDomainSet("CONSENSO_PRECONTRATTUALE", "M10")
          .then(function (response) {
            var test = self.model.leasingData.preventivo.flagsArc
                      .some(function(element){
                          return element.name == response.domainList[0].name
                      })
            if(!test){
              self.model.leasingData.preventivo.flagsArc.push(FlagArc.build(response.domainList[0]));
            }
            
          
        })
  }

  self.check = function(el){
    el.selected = !el.selected;
    everyFileIsDownloaded();
  }
  
}